module.exports = __webpack_public_path__ + "assets/img/fuguoing3.dbb51d0c.png";